export default __webpack_public_path__ + "static/media/stoplight.969e050e.svg";